import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import office from "../assets/img/ank.jpg"
import office1 from "../assets/img/kadikoy.webp"
import peopleIcon from "../assets/img/people-icon.png"
import mailIcon from "../assets/img/mail-icon.png"
import callIcon from "../assets/img/call-icon.png"
import insta1 from "../assets/img/flatart-insta-ss1.png"
import insta2 from "../assets/img/flatart-insta-ss2.png"

class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formStatus: "idle",
      statusMessage: "",
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({ formStatus: "submitting" })

    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=8", {
      method: "POST",
      body: JSON.stringify({
        text_457735: document.querySelector("#ad").value,
        text_967447: document.querySelector("#eposta").value,
        text_314200: document.querySelector("#sirket").value || "-",
        text_959769: document.querySelector("#telefon").value,
        text_901991: document.querySelector("#mesaj").value || "-",
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })

    response
      .then(res => {
        if (!res.ok) throw new Error("HTTP " + res.status)
        return res.json()
      })
      .then(data => {
        if (data.success) {
          this.setState({ formStatus: "success", statusMessage: "Your message has been sent successfully." })
          setTimeout(() => { window.location.reload() }, 5000)
        } else {
          const msg = data.message || ""
          const isLimit = msg.includes("no longer accepting") || msg.toLowerCase().includes("limit")
          this.setState({
            formStatus: "error",
            statusMessage: isLimit
              ? "You have an active form submission. Please try again later."
              : "An error occurred. Please try again or call us.",
          })
        }
      })
      .catch(() => {
        this.setState({ formStatus: "error", statusMessage: "Connection error. Please try again or call us." })
      })
  }

  render() {
    const { formStatus, statusMessage } = this.state

    return (
      <Layout>
        <SEO
          title="Contact | Flatart"
          description="You can contact us by visiting our offices in Ankara and Kadıköy or filling out the contact form on our website."
        />

        {/* HERO */}
        <div className="contact container" style={{ marginTop: 20, textAlign: "center" }}>
          <h3>CONTACT US</h3>
          <h1 id="contactH1">
            We are at the connection<br />
            point of the Asian and<br />
            European continents.
          </h1>
          <p className="contactp">We welcome you to our offices in Ankara and Kadıköy.</p>

          <div className="offices row">
            <div className="offices-city col-md-6">
              <img alt="Flatart Ankara Office" src={office} />
              <h2>Ankara</h2>
              <p>
                Ümit Mah. Bina No:2 Nokta Kule<br />
                5. Kat Daire No:6 Çankaya/ANKARA
              </p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/maps/dir/39.9048704,32.6926336/flatart/@39.9029452,32.6905496,17z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x14d3470555555555:0x573dd00dc266ec0f!2m2!1d32.6929533!2d39.900412"
                className="content-link"
              >
                Get directions to our Ankara office.
              </a>
            </div>
            <div className="offices-city col-md-6">
              <img alt="Flatart Kadıköy Office" src={office1} />
              <h2>Kadıköy</h2>
              <p>
                Koşuyolu, Mahmut Yesari Cd. No: 21<br />
                34718 Kadıköy / İstanbul, Türkiye
              </p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/maps/search/?api=1&query=Ko%C5%9Fuyolu%2C%20Mahmut%20Yesari%20Cd.%20No%3A%2021%2C%2034718%20Kad%C4%B1k%C3%B6y%2F%C4%B0stanbul%2C%20T%C3%BCrkiye"
                className="content-link"
              >
                Get directions to our Kadıköy office.
              </a>
            </div>
          </div>
        </div>

        {/* CONTACT ROW */}
        <div className="contact-row">
          <div className="col-md-4">
            <img alt="Partnerships" src={peopleIcon} />
            <p>Find out what we can do for your collaborations and projects.</p>
          </div>
          <div className="col-md-4">
            <img alt="Email" src={mailIcon} />
            <p>Fill out the form to connect, and we will reply within 1 business day.</p>
            <a href="#contact-form" className="content-link">Fill the Form</a>
          </div>
          <div className="col-md-4">
            <img alt="Phone" src={callIcon} />
            <p>
              For urgent matters,<br />
              let's talk on the phone.
            </p>
            <a href="tel:+908509880200" className="content-link">+90 (850) 988 02 00</a>
          </div>
        </div>

        {/* FORM */}
        <div className="contact-end container" id="contact-form">
          <div className="col-md-6">
            <h2 style={{ marginBottom: 40 }}>
              The easiest way<br />
              to get in touch.
            </h2>

            {formStatus === "success" || formStatus === "error" ? (
              <div className={`form-result ${formStatus}`}>
                <p>{statusMessage}</p>
              </div>
            ) : (
              <form className="contact-end__form" onSubmit={e => this.handleSubmit(e)}>
                <input type="text" name="text_457735" id="ad" placeholder="Enter your name *" required />
                <input type="email" name="text_967447" id="eposta" placeholder="Enter your email *" required />
                <input
                  type="text"
                  id="telefon"
                  name="text_959769"
                  placeholder="Enter your phone number *"
                  pattern="[0-9+\-\s\(\)]+"
                  title="Please enter a valid phone number"
                  required
                />
                <input type="text" name="text_314200" id="sirket" placeholder="Enter your company" />
                <textarea id="mesaj" name="text_901991" placeholder="Enter your message"></textarea>
                <button
                  className="red-button"
                  type="submit"
                  disabled={formStatus === "submitting"}
                >
                  {formStatus === "submitting" ? "Sending..." : "SEND"}
                </button>
              </form>
            )}
          </div>

          <div className="col-md-6">
            <div className="follow">
              <h2 style={{ marginBottom: 25 }}>
                Contact us about our services and your questions!
              </h2>
            </div>
            <div className="row">
              <div className="col">
                <a href="/brands/" target="_blank" rel="noopener noreferrer">
                  <img alt="Flatart Success Stories" src={insta1} />
                </a>
              </div>
              <div className="col">
                <a href="/services/" target="_blank" rel="noopener noreferrer">
                  <img alt="Flatart Services" src={insta2} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Contact
